module.exports = {"650106001":"头屯河街道","650106002":"火车西站街道","650106003":"王家沟街道","650106004":"乌昌路街道","650106005":"北站西路街道","650106198":"头屯河区乡类似乡镇单位","650106501":"兵团十二师三坪农场","650106502":"兵团十二师五一农场","650106503":"新疆兵团十二师头屯河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650106.json
// module id = 2838
// module chunks = 0